import { render, staticRenderFns } from "./GlossDetail.vue?vue&type=template&id=80f1b192"
import script from "./GlossDetail.vue?vue&type=script&lang=ts"
export * from "./GlossDetail.vue?vue&type=script&lang=ts"
import style0 from "./GlossDetail.vue?vue&type=style&index=0&id=80f1b192&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports